// Lightweight On-Demand Pincode Checker
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Starting lightweight pincode checker...');
  console.log('📦 Zero preloading - super fast initialization');
  
  // Wait for pincode data setup or initialize immediately
  if (window.pincodeAssetURL) {
    console.log('✅ Pincode data setup found');
    initPincodeChecker();
  } else {
    // Check periodically for setup or proceed with fallback
    let checkCount = 0;
    const checkInterval = setInterval(() => {
      checkCount++;
      if (window.pincodeAssetURL || checkCount >= 10) { // Wait max 1 second
        clearInterval(checkInterval);
        if (window.pincodeAssetURL) {
          console.log('✅ Pincode data setup loaded');
        } else {
          console.log('⚡ Proceeding with fallback setup');
        }
        initPincodeChecker();
      }
    }, 100);
  }
  
  // Inline search function as fallback
  async function searchPincodeInline(pincode) {
    console.log('🔍 Inline search for pincode:', pincode);
    
    // Use cache if available
    if (!window.pincodeSearchCache) {
      window.pincodeSearchCache = new Map();
    }
    
    if (window.pincodeSearchCache.has(pincode)) {
      const cached = window.pincodeSearchCache.get(pincode);
      console.log('⚡ Found in cache:', cached);
      return cached;
    }
    
    try {
      // Try to use the JavaScript database if window.loadPincodeDatabase exists
      if (typeof window.loadPincodeDatabase === 'function') {
        console.log('🔄 Using JavaScript database loader');
        const database = await window.loadPincodeDatabase();
        const found = database.find(item => String(item.Pincode) === String(pincode));
        
        if (found) {
          console.log('✅ Pincode found in JS database:', found);
          window.pincodeSearchCache.set(pincode, found);
          return found;
        } else {
          console.log('❌ Pincode not found in JS database');
          window.pincodeSearchCache.set(pincode, null);
          return null;
        }
      }
      
      // Fallback: Try direct database access if available
      if (window.PINCODE_DATABASE && window.PINCODE_DATABASE.length > 0) {
        console.log('🔄 Using direct database access');
        const found = window.PINCODE_DATABASE.find(item => String(item.Pincode) === String(pincode));
        
        if (found) {
          console.log('✅ Pincode found in direct database:', found);
          window.pincodeSearchCache.set(pincode, found);
          return found;
        } else {
          console.log('❌ Pincode not found in direct database');
          window.pincodeSearchCache.set(pincode, null);
          return null;
        }
      }
      
      throw new Error('No database loading method available');
      
    } catch (error) {
      console.error('💥 Inline search failed:', error.message);
      console.log('🔍 Database access issue - check pincode-database.js file in assets');
      return null;
    }
  }

  function initPincodeChecker() {
    const pincodeContainers = document.querySelectorAll('.product__pincode-check');
    console.log('🎯 Initializing lightweight on-demand pincode checker');
    
    pincodeContainers.forEach(container => {
      const input = container.querySelector('.pincode-input');
      const button = container.querySelector('.pincode-button');
      const result = container.querySelector('.pincode-result');
      const header = container.querySelector('.pincode-check__header');
      
      if (!input || !button || !result) return;
      
      // Create "Check another pincode" link
      const checkAnother = document.createElement('a');
      checkAnother.textContent = 'Check another pincode';
      checkAnother.href = '#';
      checkAnother.className = 'check-another-link';
      checkAnother.style.display = 'none';
      if (header) header.appendChild(checkAnother);
      
      // Helper to reset form
      function resetForm() {
        input.style.display = '';
        button.style.display = '';
        if (checkAnother) checkAnother.style.display = 'none';
        input.value = '';
        result.textContent = '';
        input.focus();
      }
      
      checkAnother.addEventListener('click', function(e){
        e.preventDefault();
        resetForm();
      });
      
      // Check for existing pincode cookie and auto-check
      const savedPincode = getCookie('user_pincode');
      if (savedPincode) {
        console.log('Found saved pincode:', savedPincode);
        input.value = savedPincode;
        // Auto-check the saved pincode after a short delay
        setTimeout(() => {
          checkPincode(input, button, result, checkAnother, true);
        }, 500);
      }
      
      // Allow only numeric input and auto-check on 6 digits
      let autoTimeout;
      input.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length === 6) {
          checkPincode(input, button, result, checkAnother);
        }
      });
      
      // Enable checking with Enter key
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPincode(input, button, result, checkAnother);
        }
      });
      
      // Button click handler
      button.addEventListener('click', function() {
        checkPincode(input, button, result, checkAnother);
      });
    });
  }

  async function checkPincode(input, button, result, checkAnother, isAutoCheck = false) {
    const pin = input.value.trim();
    
    // Validate pincode format
    if (!pin || pin.length < 6) {
      result.textContent = 'Please enter a valid 6-digit pincode';
      result.style.color = '#cc0000';
      if (checkAnother) checkAnother.style.display = 'inline';
      return;
    }
    
    // Show loading state
    if (!isAutoCheck) {
      button.disabled = true;
      const originalButtonText = button.textContent;
      button.textContent = 'Checking...';
      result.textContent = 'Searching database...';
    }
    
    console.log('🔍 On-demand search for pincode:', pin);
    
    try {
      // Use the lightweight on-demand search or create it if not available
      let entry = null;
      
      if (typeof window.searchPincode === 'function') {
        entry = await window.searchPincode(pin);
      } else {
        // Fallback: create the search function inline
        console.log('🔄 Creating inline search function');
        entry = await searchPincodeInline(pin);
      }
      
      const processResult = () => {
        if (entry) {
          const transitDays = parseInt(entry["Standard Transit Days"]);
          const productionDays = 7;
          const totalDays = transitDays + productionDays;
          const deliveryDate = getDeliveryDate(totalDays);
          
          // Display result
          const deliveryMessage = isAutoCheck ? 
            `<div class="delivery-result-single-line auto-check">
              <span class="delivery-date-left"><span class="delivery-check">✓</span> Estimated delivery by: <strong>${deliveryDate}</strong></span>
              <span class="cod-available-right"><span class="delivery-check">✓</span> COD Available</span>
            </div>` :
            `<div class="delivery-result-single-line">
              <span class="delivery-date-left"><span class="delivery-check">✓</span> Estimated delivery by: <strong>${deliveryDate}</strong></span>
              <span class="cod-available-right"><span class="delivery-check">✓</span> COD Available</span>
            </div>`;
          
          result.innerHTML = deliveryMessage;
          result.style.color = '';
          
          // Hide input/button and show result
          input.style.display = 'none';
          button.style.display = 'none';
          
          // Show check another link
          if (checkAnother) checkAnother.style.display = 'inline-block';
          
          // Save to cookies
          if (!isAutoCheck) {
            setCookie('user_pincode', pin, 30);
            setCookie('user_location', pin, 30);
            console.log('✅ Pincode saved to cookie');
          }
        } else {
          result.textContent = 'Delivery not available for this pincode';
          result.style.color = '#cc0000';
          if (checkAnother) checkAnother.style.display = 'inline';
          
          // Clear cookies
          setCookie('user_pincode', '', -1);
          setCookie('user_location', '', -1);
        }
        
        // Reset button state
        if (!isAutoCheck) {
          button.disabled = false;
          button.textContent = 'Check Delivery Date';
        }
      };
      
      // Add slight delay for better UX
      if (isAutoCheck) {
        processResult();
      } else {
        setTimeout(processResult, 300);
      }
      
    } catch (error) {
      console.error('💥 Pincode search failed:', error);
      
      result.textContent = 'Error checking pincode. Please try again.';
      result.style.color = '#cc0000';
      
      if (!isAutoCheck) {
        button.disabled = false;
        button.textContent = 'Check Delivery Date';
      }
    }
  }

  function getDeliveryDate(daysToAdd) {
    const date = new Date();
    date.setDate(date.getDate() + daysToAdd);
    
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }

  // Cookie helper functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }
  
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}); 